let scriptCache = [];

let isScriptAdded = (url) => {
  return scriptCache.includes(url);
};

let addScript = async (url, options = {}) => {
  if (isScriptAdded(url)) {
    return true;
  }

  return forceAddScript(url, options);
};

let forceAddScript = async (url, options = {}) => {
  if (utilities.isSSR()) {
    return true;
  }

  return new Promise((fulfil, reject) => {
    let script = document.createElement("script");
    script.src = url; // URL for the third-party library being loaded.
    script.id = "added-script-" + utilities.getUniqueNumber(); // e.g., googleMaps or stripe
    document.body.appendChild(script);

    script.onload = () => {
      fulfil(true);
    };
  });
};

let addLiteralScript = async (content, options = { escape: true }) => {
  if (utilities.isSSR()) {
    return true;
  }

  return new Promise((fulfill, reject) => {
    const script = document.createElement("script");

    script.textContent = options.escape
      ? content.replace(/\n/g, "\\n")
      : content;
    document.head.appendChild(script);
    script.onload = () => {
      fulfill(true);
    };

    script.onerror = (error) => {
      reject(error);
    };
  });
};

export default (props) => {
  return { addScript, forceAddScript, addLiteralScript };
};
